import { createContext, useContext } from "react";

/** Lets a control panel tell the page that the audit's scores may have changed. A no-op outside an audit. */
const AuditRefreshContext = createContext(() => {});

export const AuditRefreshProvider = AuditRefreshContext.Provider;

export const useAuditRefresh = () => useContext(AuditRefreshContext);
